import { Grid, styled, Typography } from "@mui/material";
import { ReactComponent as Teach } from "assets/icons/teach.svg";
import { UnauthenticatedLayout } from "components/UnauthenticatedLayout";
import { RegisterPageForm } from "./RegisterPageForm";

const PREFIX = "RegisterPage";

const classes = {
	container: `${PREFIX}-container`,
	leftPanel: `${PREFIX}-leftPanel`,
	rightPanel: `${PREFIX}-rightPanel`,
	welcomeTitle: `${PREFIX}-welcomeTitle`,
	welcomeSubtitle: `${PREFIX}-welcomeSubtitle`,
	image: `${PREFIX}-image`,
};

const StyledUnauthenticatedLayout = styled(UnauthenticatedLayout)(
	({ theme }) => ({
		// Pull the card up above the fold (overrides the shared layout's large top offset)
		"&.UnauthenticatedLayout-root": {
			marginTop: "72px",
			paddingTop: "16px",
			paddingBottom: "32px",
		},

		[`& .${classes.container}`]: {
			width: "100%",
			maxWidth: "1200px",
			margin: "0 auto",
			minHeight: "calc(100vh - 200px)",
			borderRadius: "24px",
			overflow: "hidden",
			boxShadow: theme.shadows[8],
			backgroundColor: theme.palette.background.paper,
		},

		[`& .${classes.leftPanel}`]: {
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			justifyContent: "center",
			padding: theme.spacing(6),
			textAlign: "center",
			background: "linear-gradient(135deg, #3A66D4 0%, #2E54B8 100%)",
		},

		[`& .${classes.rightPanel}`]: {
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			justifyContent: "center",
			padding: theme.spacing(4),
			background: "linear-gradient(135deg, #1E3A8A 0%, #172E6E 100%)",
		},

		[`& .${classes.welcomeTitle}`]: {
			color: "#FFFFFF",
			fontWeight: 700,
			marginBottom: theme.spacing(1.5),
		},

		[`& .${classes.welcomeSubtitle}`]: {
			color: "rgba(255, 255, 255, 0.92)",
			fontWeight: 400,
			marginBottom: theme.spacing(4),
		},

		[`& .${classes.image}`]: {
			width: "75%",
			maxWidth: "420px",
			height: "auto",
			opacity: 0.95,
		},
	}),
);

export const RegisterPage = (): JSX.Element => (
	<StyledUnauthenticatedLayout>
		<Grid container className={classes.container}>
			<Grid item xs={12} md={6} className={classes.leftPanel}>
				<Typography variant="h3" className={classes.welcomeTitle}>
					Create Your Account!
				</Typography>
				<Typography variant="h6" className={classes.welcomeSubtitle}>
					Create assignments, track student progress, and make STEM fun!
				</Typography>
				<Teach className={classes.image} />
			</Grid>
			<Grid item xs={12} md={6} className={classes.rightPanel}>
				<RegisterPageForm />
			</Grid>
		</Grid>
	</StyledUnauthenticatedLayout>
);
